export const getGeo = () =>
  new Promise((resolve, reject) => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        position => resolve(position),
        error => reject(error),
        {
          timeout: 5000,
        },
      )
    } else {
      reject('Location services unavailable')
    }
  })
